import {useSyncExternalStore} from 'react';
import {getPublicSalesEventConnectionState, observePublicSalesEventConnection} from './public-sales-events';

const priority = ['offline', 'interrupted', 'retrying', 'connecting'];
const serverState = () => 'connecting';

// Observe existing subscriptions, never create a second connection or join.
export default function useAuctionConnection(lots) {
    return useSyncExternalStore(observePublicSalesEventConnection, () => {
        const states = lots.map(({productUuid, lotId}) => getPublicSalesEventConnectionState(productUuid, lotId));
        return priority.find(state => states.includes(state)) ?? 'live';
    }, serverState);
}

export function isAuctionConnectionInterrupted(state) {
    return ['offline', 'retrying', 'interrupted'].includes(state);
}
